export const isTiff = file => file.type === 'image/tiff';

export const isJpeg = file => file.type === 'image/jpeg';

export const isImg = file => isTiff(file) || isJpeg(file);
